import {
  changeStatusPackage,
  deleteAllPackageItem,
  deletePackage,
  duplicatePackage,
  exportListPackage,
  getListPackage,
  createNewPackage,
  getPaymentType,
  getPackageDetails,
  updatePackage,
  getMenuV2PreviewLink,
  getPackageSubmission,
  getPackageSubmissionDetail,
  getPackageSubmissionPaymentType,
  approvePackageSubmission,
  rejectPackageSubmission,
} from "@/api/package";
import { defineStore } from "pinia";
import { transformToFormDataDynamic } from "@/utils/global.util";

export const usePackageStore = defineStore({
  id: "package",
  state: () => ({
    data: [],
    pagination: {},
    paymentChargeAmount: 0,
    menuLayout: null,
    packageDetaills: null,
    menuSections: [],
    delivery: {
      customDeliveryFee: true,
      deliveryFeeCurrency: "thb",
      deliveryFee: 0,
      deliveryFeePerKm: 10,
      freeDeliveryKm: 5,
      freeDeliveryFeeThreshold: 5,
    },
    hotelType: {
      specifyRoom: false,
      customRoomName: "",
      checkInTime: null,
      checkOutTime: null,
    },
    packageForm: {
      packageType: null,
      package: {
        nameEn: "",
        nameTh: "",
        descriptionEn: "",
        descriptionTh: "",
        menuType: "img",
        menuLinks: null,
        specialAgenda: false,
        noOfCourses: 0,
        noOfDrinks: 0,
        noOfAdults: 0,
        requireCc: false,
        chargeType: "on_hold",
        chargeAmountType: "relative",
        chargePolicyEn: "en",
        chargePolicyTh: "th",
        // specifyRoom: false, // only hotel
        // customRoomName: "",
        // checkInTime: "",
        // checkOutTime: "",
        reservationDuration: 0,
      },
      agendasAttributes: [],
      restaurantPackagesAttributes: [
        {
          autoExtend: false,
          startDate: null,
          endDate: null,
        },
      ],
      packageMenusAttributes: [],
      packageAttrAttributes: {
        largestTable: 0,
        maxSeat: 0,
        minimumBookingTimeInAdvance: 0,
        customNetPrice: 0,
        originalPriceCents: 0,
        useKidsPrice: false,
        chargePolicyLinkEn: null,
        chargePolicyLinkTh: null,
        packagePaymentTypesAttributes: [],
        chargePolicyImagesAttributes: {
          en: {
            id: null,
            image: null,
          },
          th: {
            id: null,
            image: null,
          },
        },
      },
      kidsPricesAttributes: [],
      pricingAttributes: [],
    },
    packageMenu: {
      menuLink: null,
      menuType: null,
      menuImg: null,
      menuV2: null,
    },
    closedDays: [],
    paymentTypes: [],
  }),
  getters: {
    getListData: (state) => state.data,
    getPagination: (state) => state.pagination,
  },
  actions: {
    getListPackage(payload) {
      return new Promise((resolve, reject) => {
        getListPackage(payload)
          .then((response) => {
            const formatDate = new Intl.DateTimeFormat("en-GB", {
              year: "numeric",
              day: "numeric",
              month: "short",
            });
            const getPrice = (item) => {
              if (item.packageTypeShort?.toLowerCase() !== "diy") {
                return item.netPrice;
              }

              if (item.hasSpendingTierDiscount) {
                return `Min. Spend ${item.minSpending?.format ?? "-"}`;
              } else {
                return "No Min. Spend";
              }
            };
            const dataFormat = response.data.map((item) => {
              const { attributes, id, type } = item;
              const dataItem = {
                id: id,
                type: type,
                packageId: attributes.packageId,
                status: attributes.active,
                packageName: attributes.packageName,
                packageType: {
                  type: attributes.packageType,
                  typeShort: attributes.packageTypeShort,
                  color: attributes.colorCode,
                },
                price: getPrice(attributes),
                bookingDuration: attributes.bookingDuration,
                url: attributes.url,
                pricingType:
                  attributes.packageTypeShort === "diy"
                    ? "person"
                    : attributes.pricingType?.replace("per_", ""),
                createAt: formatDate.format(new Date(attributes.createdAt)),
                updatedAt: formatDate.format(new Date(attributes.updatedAt)),
                menuType: attributes.menuType,
                menuImg: attributes.menuImg,
                menuLinks: attributes.menuLinks,
                menuV2: attributes.hhMenuV2HtmlPreviewLink,
                isPreviewMode: attributes.isVisibleForStaff,
                restaurantName: attributes.restaurantName,
                submissionStatus: attributes.submissionStatus,
                rejectReason: attributes.rejectReason,
                canEdit: attributes.canEdit,
                coverImage: attributes.coverImage,
                createdByAdmin: attributes.createdByAdmin,
                canToggle: attributes.canToggle,
                canEditOtherFields: attributes.canEditOtherFields,
                restaurantId: attributes.restaurantId,
                restaurants: Array.isArray(attributes.restaurants)
                  ? attributes.restaurants.map((r) => ({
                      id: r.id ?? r.restaurantId,
                      name: r.name,
                      url: r.url,
                    }))
                  : [],
              };
              return dataItem;
            });

            const dataActive = dataFormat.filter((item) => item.status);
            const dataPreview = dataFormat.filter((item) => item.isPreviewMode);
            const dataInactive = dataFormat.filter((item) => !item.status);
            this.data = dataActive.concat(dataPreview, dataInactive);
            this.data = [...new Set(this.data)];
            this.pagination = response.meta;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createNewPackage(restaurantId, packageType, payload) {
      const formData = new FormData();
      const postData = transformToFormDataDynamic(payload, formData);
      return new Promise((resolve, reject) => {
        createNewPackage(restaurantId, packageType, postData)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPaymentType(restaurantId) {
      return new Promise((resolve, reject) => {
        getPaymentType(restaurantId)
          .then((response) => {
            this.paymentTypes = response.data;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPackageDetail(id) {
      return new Promise((resolve, reject) => {
        getPackageDetails(id)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updatePackage(id, payload) {
      const formData = new FormData();
      const postData = transformToFormDataDynamic(payload, formData);
      return new Promise((resolve, reject) => {
        updatePackage(id, postData)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleChangeStatus(payload) {
      return new Promise((resolve, reject) => {
        changeStatusPackage(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    exportListPackage(payload) {
      return new Promise((resolve, reject) => {
        exportListPackage(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    duplicatePackage(payload) {
      return new Promise((resolve, reject) => {
        duplicatePackage(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deletePackage(id) {
      return new Promise((resolve, reject) => {
        deletePackage(id)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteAllPackageItem() {
      return new Promise((resolve, reject) => {
        deleteAllPackageItem()
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    resetPackageForm() {
      this.packageDetaills = null;
      this.paymentChargeAmount = null;
      this.menuSections = [];
      this.delivery = {
        customDeliveryFee: true,
        deliveryFeeCurrency: "thb",
        deliveryFee: 0,
        deliveryFeePerKm: 10,
        freeDeliveryKm: 5,
      };
      this.hotelType = {
        specifyRoom: false,
        customRoomName: "",
        checkInTime: null,
        checkOutTime: null,
      };
      this.packageForm = {
        packageType: null,
        package: {
          nameEn: "",
          nameTh: "",
          descriptionEn: "",
          descriptionTh: "",
          menuType: "img",
          menuLinks: null,
          specialAgenda: false,
          noOfCourses: 0,
          noOfDrinks: 0,
          noOfAdults: 0,
          requireCc: false,
          chargeType: "on_hold",
          chargeAmountType: "relative",
          chargePolicyEn: "en",
          chargePolicyTh: "th",
          // specifyRoom: false, // only hotel
          // customRoomName: "",
          // checkInTime: "",
          // checkOutTime: "",
          reservationDuration: 0,
        },
        agendasAttributes: [],
        restaurantPackagesAttributes: [
          {
            autoExtend: false,
            startDate: null,
            endDate: null,
          },
        ],
        packageMenusAttributes: [],
        packageAttrAttributes: {
          largestTable: 0,
          maxSeat: 0,
          minimumBookingTimeInAdvance: 0,
          customNetPrice: 0,
          originalPriceCents: 0,
          useKidsPrice: false,
          chargePolicyLinkEn: "",
          chargePolicyLinkTh: "",
          packagePaymentTypesAttributes: [],
          chargePolicyImagesAttributes: {
            en: {
              id: null,
              image: null,
            },
            th: {
              id: null,
              image: null,
            },
          },
        },
        kidsPricesAttributes: [],
        pricingAttributes: [],
      };
    },
    getMenuV2Preview(link) {
      return new Promise((resolve, reject) => {
        getMenuV2PreviewLink(link)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPackageSubmission(submissionId, payload) {
      return new Promise((resolve, reject) => {
        getPackageSubmission(submissionId, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPackageSubmissionDetail(restaurantPackageId, payload) {
      return new Promise((resolve, reject) => {
        getPackageSubmissionDetail(restaurantPackageId, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPackageSubmissionPaymentType(payload) {
      return new Promise((resolve, reject) => {
        getPackageSubmissionPaymentType(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    approvePackageSubmission(submissionId, payload, token) {
      const formData = new FormData();
      const postData = transformToFormDataDynamic(payload, formData);
      return new Promise((resolve, reject) => {
        approvePackageSubmission(submissionId, postData, token)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    rejectPackageSubmission(submissionId, payload, token) {
      return new Promise((resolve, reject) => {
        rejectPackageSubmission(submissionId, payload, token)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
});
